// if orders count more than this number we can't calculate 4-sum combinations for performance reasons
export const ORDERS_LIMIT_FOR_4_SUM = 30

// if orders count more than this number we can't calculate N-sum combinations for performance reasons
export const ORDERS_COUNT_WITH_GUARANTEED_MATCH = 8

// maximum amount od EOS spent for RAM when creating a new EOS account
export const EOS_MAX_RAM_COST = 1

export const DEFAULT_ORDER_TO_AMOUNT_SLIPPAGE = 3
